import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import User from 'models/user/user.model';
import IdTokenPayload from 'models/id-token-payload/id-token-payload.model';
import Log from 'models/log/log.model';
import OidcClientData from 'models/oidc-client-data.model.ts/oidc-client-data.model';
import OrganizationUnit from 'models/organization-unit/organization-unit.model';
import ApiResponse from 'models/api-response/api-response.model';
import { TokenService } from 'services/token/token-service.service';
import { ApiRequestService } from 'services/api-request/api-request.service';
import { LogService } from 'services/log/log.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {
  private currentUser: BehaviorSubject<User> = new BehaviorSubject(new User());

  constructor(
    public tokenService: TokenService,
    public logService: LogService,
    public apiRequestService: ApiRequestService,
  ) {
    tokenService.getTokenRefreshSubject().subscribe(async (data: OidcClientData) => {
      if (data && data.idToken.length > 0) {
        await this.parseIdToken();
      }
    });
  }

  public async parseIdToken(): Promise<User> {
    return new Promise(async (resolve: (r: User) => any, reject: (e: Error) => any) => {
      const decoded: IdTokenPayload = await this.tokenService.decodeIdToken();
      this.currentUser.next(new User({
        firstName: decoded.givenName,
        lastName: decoded.familyName,
        email: decoded.email,
        username: decoded.preferredUsername,
        memberOf: decoded.memberOf,
      }));
      return resolve(this.currentUser.value);
    });
  }

  public async findByOu(ou: OrganizationUnit): Promise<User[]> {
    return new Promise((resolve: (r: User[]) => any, reject: (e: Error) => any) => {
        this.apiRequestService.post('/user/findbyou/', {
          organizationUnit: ou.name
        }).subscribe({
            next: async (res: ApiResponse<User[]>) => {
                if (!res.success) {
                    await this.logService.create(new Log({
                        description: 'requestError: ' + JSON.stringify(res),
                        event: 'serviceError',
                        performer: 'UserService.findByOu',
                        type: 'error'
                      }));
                    return reject(new Error('requestError'));
                }
                const resArr: User[] = [];
                res.data.forEach(element => resArr.push(new User(element)));
                return resolve(resArr);
            },
            error: async error => {
              console.log(error);
              await this.logService.create(new Log({
                description: error,
                event: 'serviceError',
                performer: 'UserService.findByOu',
                type: 'error'
              }));
              return reject(new Error('requestError'));
            }
          });
    });
  }

  public getCurrentUser(): BehaviorSubject<User> {
    return this.currentUser;
  }
}
